var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewsletterMailMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41,6H7c-2.7568359,0-5,2.2431641-5,5v24c0,2.7568359,2.2431641,5,5,5h34c2.7568359,0,5-2.2431641,5-5V11 C46,8.2431641,43.7568359,6,41,6z M41,8c0.461731,0,0.8942261,0.1134644,1.2853394,0.3005981L26.7070312,23.8789062 C25.9941406,24.5917969,25.0078125,25,24,25s-1.9941406-0.4082031-2.7070312-1.1210938L5.7146606,8.3005981 C6.1057739,8.1134644,6.538269,8,7,8H41z M7,38c-0.461731,0-0.8942261-0.1134644-1.2853394-0.3005981l10.9923706-10.9923706 l-1.4140625-1.4140625L4.3005981,36.2853394C4.1134644,35.8942261,4,35.461731,4,35V11 c0-0.461731,0.1134644-0.8942261,0.3005981-1.2853394l15.5783081,15.5783081C20.9638672,26.3779297,22.4658203,27,24,27 s3.0361328-0.6220703,4.1210938-1.7070312L43.6994019,9.7146606C43.8865356,10.1057739,44,10.538269,44,11v24 c0,0.461731-0.1134644,0.8942261-0.3005981,1.2853394L32.7070312,25.2929688l-1.4140625,1.4140625l10.9923706,10.9923706 C41.8942261,37.8865356,41.461731,38,41,38H7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletterMailMedium);
export default __webpack_public_path__ + "static/media/newsletter-mail--medium.a3c2fe281b2446594a99b41a27b6e1f8.svg";
export { ForwardRef as ReactComponent };